export enum ImportDetailsDialogResultModel {
  ImportAnotherFile,
  CategorizeTransactions
}
